import Rellax from 'rellax';

const rellax = (): void => {
  new Rellax('.rellax', {
    speed: -0.7,
    center: false,
    round: true,
    vertical: true,
    horizontal: false,
  });
};

export default rellax;
